module.exports = __webpack_public_path__ + "static/img/slogan.aa3b114.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slogan.gif
// module id = HXrR
// module chunks = 82